import React from 'react';

/**
 * FirstMealInsightModal - Shows after user logs their first meal
 * Celebrates the achievement and nudges toward profile completion
 */
const FirstMealInsightModal = ({
  show,
  mealData,
  userProfile,
  userTier,
  onClose,
  onCompleteProfile,
  onShowPremiumPrompt,
  getGenericInsight
}) => {
  if (!show || !mealData) return null;
  
  const insight = userProfile 
    ? { icon: '✨', text: 'Great start! Your meal has been logged with personalized tracking.' }
    : getGenericInsight(mealData);
  
  const handleOverlayClick = () => {
    onClose();
    // Show premium prompt after dismissing first meal insight (for free users)
    if (userTier === 'free' && !userProfile) {
      setTimeout(() => onShowPremiumPrompt(), 500);
    }
  };
  
  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '16px' }}>🎉 First Meal Logged!</h2>
        
        {/* Meal summary - MACROS ARE FREE */}
        <div style={{
          background: 'rgba(76, 175, 80, 0.1)',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '12px' }}>
            {mealData?.food_items || 'Your meal'}
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
            <div>
              <p style={{ fontSize: '24px', fontWeight: '700', color: '#4caf50', margin: 0 }}>
                {mealData?.calories || 0}
              </p>
              <p style={{ fontSize: '11px', color: 'var(--text-secondary)', margin: 0 }}>calories</p>
            </div>
            {/* Macros are FREE - always show them */}
            <div>
              <p style={{ fontSize: '18px', fontWeight: '600', color: '#2196f3', margin: 0 }}>
                {mealData?.protein || 0}g
              </p>
              <p style={{ fontSize: '11px', color: 'var(--text-secondary)', margin: 0 }}>protein</p>
            </div>
            <div>
              <p style={{ fontSize: '18px', fontWeight: '600', color: '#ff9800', margin: 0 }}>
                {mealData?.carbs || 0}g
              </p>
              <p style={{ fontSize: '11px', color: 'var(--text-secondary)', margin: 0 }}>carbs</p>
            </div>
            <div>
              <p style={{ fontSize: '18px', fontWeight: '600', color: '#e91e63', margin: 0 }}>
                {mealData?.fat || 0}g
              </p>
              <p style={{ fontSize: '11px', color: 'var(--text-secondary)', margin: 0 }}>fat</p>
            </div>
          </div>
        </div>
        
        {/* MIQ Learning indicator */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
          border: '1px solid rgba(102, 126, 234, 0.2)',
          borderRadius: '10px',
          padding: '12px',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          <p style={{ margin: 0, fontSize: '13px', color: 'var(--text-secondary)' }}>
            🧠 <strong style={{ color: '#667eea' }}>MIQ is learning</strong> — 1 factor computed
          </p>
        </div>
        
        {/* Insight */}
        <div style={{
          background: 'var(--bg-card)',
          border: '1px solid var(--border-color)',
          borderRadius: '10px',
          padding: '14px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px'
        }}>
          <span style={{ fontSize: '24px' }}>{insight.icon}</span>
          <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>{insight.text}</p>
        </div>
        
        {/* CTA - Complete Profile or Continue */}
        {!userProfile ? (
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => {
                onClose();
                onCompleteProfile();
              }}
              className="btn-primary"
              style={{ flex: 2 }}
            >
              📋 Complete Profile
            </button>
            <button
              onClick={() => {
                onClose();
                setTimeout(() => onShowPremiumPrompt(), 500);
              }}
              className="btn-secondary"
              style={{ flex: 1 }}
            >
              Later
            </button>
          </div>
        ) : (
          <button
            onClick={onClose}
            className="btn-primary full-width"
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
};

export default FirstMealInsightModal;
